import type {
  PersonModel,
  RelationModel,
} from 'src/tpbp-json-api-handler/models/models'
import type { MaritalStatuses } from 'src/circuits/transmission-circuit/shared/transmission-circuit.const'
import { MARITAL_STATUSES } from 'src/circuits/transmission-circuit/shared/transmission-circuit.const'
import { RELATION_ROLES } from 'src/services/mappings/relation/relation.const'

export function verifyCurrentUserHasPartner(
  currentUserMaritalStatus: MaritalStatuses,
  currentUserPartner: PersonModel | undefined,
): boolean {
  return (
    currentUserMaritalStatus !== MARITAL_STATUSES.single && !!currentUserPartner
  )
}

export function getHouseholdPersons({
  currentUser,
  currentUserHasPartner,
  currentUserPartner,
}: {
  currentUser: PersonModel
  currentUserHasPartner: boolean
  currentUserPartner: PersonModel | undefined
}): PersonModel[] {
  return [
    currentUser,
    currentUserHasPartner ? currentUserPartner : undefined,
  ].filter(Boolean) as PersonModel[]
}

export function getCurrentUserPartnerRelationAmongAllRelations<
  T extends { role: ValueOf<typeof RELATION_ROLES> },
>(currentUserRelations: T[]): T | undefined {
  return currentUserRelations.find(
    (relation) => relation.role === RELATION_ROLES.partner,
  )
}

export function getLegalRepresentatives(
  relations: RelationModel[],
): PersonModel[] {
  const legalRepresentativesRelations = relations.filter(
    (relation) => relation.role === RELATION_ROLES.legalRepresentative,
  )
  return legalRepresentativesRelations.map(
    (legalRepresentativeRelation) => legalRepresentativeRelation._subject,
  )
}

export function getCurrentUserPartner({
  partnerRelationSubject,
  partnerRelationRelatedTo,
  currentUserId,
}: {
  partnerRelationSubject: PersonModel | undefined
  partnerRelationRelatedTo: PersonModel | undefined
  currentUserId: string
}): PersonModel | undefined {
  if (!partnerRelationRelatedTo || !partnerRelationSubject) return

  if (currentUserId === partnerRelationSubject?.id)
    return partnerRelationRelatedTo

  if (currentUserId === partnerRelationRelatedTo?.id)
    return partnerRelationSubject

  return
}
